import React, { useEffect, useState } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import Config from "../../Config";
import { pastOrderId } from "../../../utils/pastOrders";
import { InvoiceRequest } from "../../PublicInvoice";
import { Sprite } from "./icons";
import { authHeaders } from "./pastApi";

/**
 * /orders/:id/invoice — la facture PEPPOL dans l'app (voir PublicInvoice).
 * L'onglet Passées passe le jeton et l'identifiant WOSH dans l'état de
 * navigation ; après un rechargement, on les relit dans past_orders.
 */
export function OrderInvoice({ match, location, history, authUser }) {
  const { t } = useTranslation("app");
  const id = String(match?.params?.id ?? "");
  const [order, setOrder] = useState(location?.state?.token ? location.state : null);
  const [lookedUp, setLookedUp] = useState(Boolean(order));

  useEffect(() => {
    if (lookedUp) return;
    Axios({ url: `${Config.apiURL}/customer/orders`, method: "GET", headers: authHeaders(authUser) })
      .then((response) => {
        const found = (response?.data?.past_orders || []).find((item) => String(item.id) === id);
        if (found) setOrder({ token: found.secure_token, woshId: pastOrderId(found) });
      })
      .catch(() => {})
      .finally(() => setLookedUp(true));
  }, [lookedUp, authUser, id]);

  const back = () => history.push("/orders?tab=past");

  return (
    <div className="wosh-ord">
      <Sprite />
      <div className="wosh-inv-page__body">
        {lookedUp ? (
          <InvoiceRequest
            token={order?.token}
            orderLabel={order?.woshId ? t("orderDetail.eyebrow", { id: order.woshId }) : null}
            authUser={authUser}
            onBack={back}
            onDone={back}
          />
        ) : (
          <div className="wosh-od__state" aria-busy="true">
            <span className="wosh-ord__spinner" />
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authUser: state?.auth?.user,
});

export default connect(mapStateToProps)(OrderInvoice);
